<template>

</template>

<script>
    export default{
        created(){
            this.$store.dispatch('user/clearUser');
            this.$auth.destroyToken();
            this.$router.push('/login');
        }
    }
</script>